<template>
  <div class="rounded p-3 border">
    <div class="d-flex justify-content-between">
      <span class="font-weight-bold">{{ template.name }}</span>

      <div class="d-flex">
        <base-switcher
          v-model="isActive"
          :disabled="isLoading"
          class="switcher mt-2"
          @change="changeTemplateAvailableDebounced"
        />

        <div class="ml-3 d-flex flex-column">
          <b-button
            v-b-tooltip.hover
            variant="light"
            size="sm"
            :disabled="isLoading"
            class="border border-primary p-1"
            title="Редактировать"
            @click="openEditModal"
          >
            <b-icon icon="pencil-square" />
          </b-button>

          <b-button
            v-b-tooltip.hover
            variant="light"
            :disabled="isLoading"
            size="sm"
            class="border border-danger mt-2 p-1"
            title="Удалить"
            @click="openDeleteAgreeModal"
          >
            <b-icon icon="trash" />
          </b-button>
        </div>
      </div>
    </div>

    <div class="crm-item-row">
      <span class="text-secondary">
        Шаблон активен с {{ startDate }}
      </span>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { parseISO, format } from 'date-fns';

import { BaseSwitcher } from '@/components/base';

const FETCH_DELAY = 700;

export default {
  name: 'ScheduleTemplateItem',
  components: {
    BaseSwitcher,
  },
  props: {
    template: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoading: false,

      isActive: this.template.isActive,
    };
  },
  computed: {
    startDate() {
      return format(parseISO(this.template.startDate), 'dd.LL.yy');
    },
  },
  watch: {
    template: {
      handler(newVal) {
        this.isActive = newVal.isActive;
      },
      deep: true,
    },
  },
  created() {
    this.changeTemplateAvailableDebounced = debounce(this.changeTemplateAvailable, FETCH_DELAY);
  },
  methods: {
    async changeTemplateAvailable() {
      if (this.isActive === this.template.isActive) return;

      this.isLoading = true;

      const isActiveTemp = this.template.isActive;

      try {
        await this.$store.dispatch(this.$types.SCHEDULE_TEMPLATE_TOGGLE_ACTIVATION,
          { templateId: this.template.id, activationState: !isActiveTemp });
      } catch (e) {
        this.isActive = isActiveTemp;
      } finally {
        this.isLoading = false;
        if (this.$store.state.SchedulePage.schedule.length) {
          this.$store.dispatch(this.$types.SCHEDULE_PAGE_FETCH, true);
        }
      }
    },
    async deleteTemplate() {
      if (this.isLoading) return;

      this.isLoading = true;

      try {
        await this.$store.dispatch(this.$types.SCHEDULE_TEMPLATE_DELETE, this.template.id);
        this.$store.commit(this.$types.TOGGLE_SCHEDULE_TRIGGER); // сделает тогл триггера и обновит расписание
      } finally {
        this.isLoading = false;
      }
    },
    openDeleteAgreeModal() {
      this.$store.commit(
        this.$types.OPEN_MODAL,
        {
          name: 'AgreeModal',
          props: { cb: this.deleteTemplate },
        },
      );
    },
    openEditModal() {
      this.$store.commit(this.$types.OPEN_MODAL, {
        name: 'ScheduleTemplateEditModal',
        props: {
          templateProp: this.template,
        },
      });
      // Bus.$emit('open-modal:schedule-edit', this.template);
    },
  },
};
</script>

<style lang="scss" scoped>
.template-item {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  box-shadow: 0px 1px 2px #C4C4C4;
  border-radius: 10px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
}
.crm-item-row {
  display: flex;
  justify-content: space-between;

  &:not(:last-child) {
    margin-bottom: 15px;
  }
}
.template-title {
  color: #1411B3;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
}
.template-start {
  font-weight: 600;
  color: $gray-dark;
}
.crm-buttons {
  display: flex;
  align-items: center;

  .switcher {
    margin-right: 30px;
  }
}
::v-deep.crm-icon {
  cursor: pointer;

  &:not(:last-child) {
    margin-right: 15px;
  }

  &.disabled {
    cursor: not-allowed;
  }

  &.progress {
    cursor: wait;
  }

  &.icon-delete:hover {
    rect {
      stroke: $red;
    }
  }

  &:not(.icon-delete):hover {
    rect {
      stroke: $blue;
    }
    path {
      fill: $blue;
    }
  }
}
</style>
